import {DateTime} from "luxon";

export const DateFormat = ({date, format}: { date: string, format?: string }) => {
  const d = DateTime.fromISO(date).setLocale('fr')
  return <div title={d.toFormat(format ?? 'dd/LLL/yyyy')}>{d.toFormat(format ?? 'dd LLL yyyy')}</div>
}

export const DateTimeFormat = ({date, format}: { date: string, format?: string }) => {
  const d = DateTime.fromISO(date).setLocale('fr')
  return <div title={d.toFormat(format ?? 'dd/LLL/yyyy HH:mm')}>{d.toFormat(format ?? 'dd LLL yyyy  HH:mm')}</div>
}

